import React, {useState} from "react";
import {Redirect, Route, Switch} from "react-router-dom";

// Chakra imports
import {Image, Flex} from "@chakra-ui/react";
import Card from "components/card/Card";
// Layout components
import {SidebarContext} from "contexts/SidebarContext";
import AnalyzePage from "../../views/admin/products/analyze";
import SignIn from "../../views/auth/signIn/SignInCentered";
import ForgotPassword from "../../views/auth/forgotPassword/ForgotPasswordCentered";
import tacitLogo3X from "../../assets/img/logo/Logotype@3x.png";

// Custom Chakra theme
export default function Auth() {
    // states and functions
    const [toggleSidebar, setToggleSidebar] = useState(false);

    return (

            <Flex  h={'100vh'}>
                <SidebarContext.Provider
                    value={{
                        toggleSidebar,
                        setToggleSidebar,
                    }}>
                    <Flex
                        flexDirection='column'
                        justifyContent='space-evenly'
                        w='100%'
                        transition='all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1)'
                        transitionDuration='.2s, .2s, .35s'
                        transitionProperty='top, bottom, width'
                        transitionTimingFunction='linear, linear, ease'
                        backgroundImage={"radial-gradient(circle closest-side at 50% 17%, rgba(244, 104, 24, 0.75) 11.98%, rgba(244, 104, 24, 0) 100%), radial-gradient(circle farthest-side at center top, rgb(244, 104, 24) 0%, rgb(255, 197, 80) 29.17%, rgb(255, 197, 80) 38.54%, rgba(241, 241, 241, 0) 100%), linear-gradient(rgba(53, 204, 187, 0) 0%, rgba(53, 204, 187, 0.2) 100%), none;"}>


                        <Flex>
                            <Image src={tacitLogo3X} h='36px' ml='0px' margin='auto'/>
                        </Flex>
                            <Switch>
                                <Route path={'/auth/login/'} key='2' component={SignIn}/>
                                <Route path={'/auth/forgot-password/'} key='3' component={ForgotPassword}/>
                                <Redirect
                                    from='/auth'
                                    to='/auth/login/'
                                />
                            </Switch>
                        <Flex h={'36px'}></Flex>

                    </Flex>
                </SidebarContext.Provider>
            </Flex>

    );
}
